import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import {
  ASSIGN_BATTERY,
  BILLING,
  INETERNAL_SWAP,
  RACK_SCREEN_DATA,
  REASSIGN_BATTERY,
  SWAP_INIT,
} from './rackScreen.types';
import rackScreenService from './rackScreenService';

const initialState = {
  isLoading: false,
  data: {} as RACK_SCREEN_DATA,
  swap: {
    animation: {
      src: '',
      alt: '',
    },
    currentStep: 0,
    warningMessage: '',
    totalBattery: 0,
    customerName: '',
    emptySlot: -1,
    //{
    //   title: 'Energy Used (kwh)',
    //   dataIndex: 'energy_consumed',
    // },
    terminateMessage: '',
    chargedSlot: -1,
    batterReceived: [],
    batteryTaken: [],
    billing: {
      amount: 0,
      swap_count: 0,
    } as BILLING,
  },
};

export const rackScreenData = createAsyncThunk(
  'rackScreenData',
  async (payload: {station_id: number; rack_id: number}, thunkAPI) => {
    try {
      const data: AxiosResponse = await rackScreenService.rackData(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const swapInitialize = createAsyncThunk(
  'swapInitialize',
  async (values: SWAP_INIT, thunkAPI) => {
    try {
      const data: AxiosResponse = await rackScreenService.swapInitialize(values);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const internalSwap = createAsyncThunk(
  'internalSwap',
  async (payload: {values: INETERNAL_SWAP; rackId: number}, thunkAPI) => {
    try {
      //console.log(values);
      const data: AxiosResponse = await rackScreenService.internalSwap(payload);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const submitBattery = createAsyncThunk(
  'submitBattery',
  async (values: {rack_id: number; station_id: number}, thunkAPI) => {
    try {
      //console.log(values);
      const data: AxiosResponse = await rackScreenService.submitBattery(values);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const assignBattery = createAsyncThunk(
  'assignBattery',
  async (values: ASSIGN_BATTERY, thunkAPI) => {
    try {
      const data: AxiosResponse = await rackScreenService.assignBattery(values);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const reAssignBattery = createAsyncThunk(
  'reAssignBattery',
  async (values: REASSIGN_BATTERY, thunkAPI) => {
    try {
      const data: AxiosResponse = await rackScreenService.reAssignBattery(values);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const rackScreenSlice = createSlice({
  name: 'rackScreenSlice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    acceptSlotOpen(state, action: PayloadAction<number>) {
      state.swap.currentStep = 1;
      state.swap.emptySlot = action.payload;
      state.swap.animation = {
        src: 'Entering.gif',
        alt: 'Insert Battery',
      };
    },
    customerData(state, action: PayloadAction<{name: string; batteries: number}>) {
      state.swap.customerName = action.payload.name;
      state.swap.totalBattery = action.payload.batteries;
    },
    batterySubmitted(state, action: PayloadAction<[]>) {
      state.swap.batterReceived = action.payload;
    },
    provisionSlotOpen(state, action: PayloadAction<number>) {
      state.swap.chargedSlot = action.payload;
      state.swap.currentStep = 1;
      state.swap.animation = {
        src: 'Removing.gif',
        alt: 'Remove Battery',
      };
    },
    batteryRemoved(state, action: PayloadAction<[]>) {
      state.swap.batteryTaken = action.payload;
    },
    billing(state, action: PayloadAction<BILLING>) {
      state.swap.billing = action.payload;
      state.swap.currentStep = 2;
    },
    billingCompleted(state) {
      state.swap.currentStep = 3;
    },
    warning(state, action: PayloadAction<string>) {
      state.swap.warningMessage = action.payload;
    },

    clearSwapState(state) {
      state.swap = initialState.swap;
    },
    terminating(state, action: PayloadAction<string>) {
      state.swap.currentStep = 9;
      state.swap.terminateMessage = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(swapInitialize.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(swapInitialize.fulfilled, (state) => {
      state.isLoading = false;
      // message.success(`Swap intialized`);
    });
    builder.addCase(swapInitialize.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(rackScreenData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(rackScreenData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    });
    builder.addCase(rackScreenData.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(internalSwap.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(internalSwap.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(internalSwap.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(assignBattery.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(assignBattery.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`Battery Assigned successfull`);
    });
    builder.addCase(assignBattery.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(reAssignBattery.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(reAssignBattery.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`Battery  ReAssigned successfull`);
    });
    builder.addCase(reAssignBattery.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(submitBattery.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(submitBattery.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(submitBattery.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});
export const {
  acceptSlotOpen,
  batterySubmitted,
  customerData,
  provisionSlotOpen,
  batteryRemoved,
  billing,
  billingCompleted,
  clearSwapState,
  terminating,
  warning,
} = rackScreenSlice.actions;
export default rackScreenSlice.reducer;
